import { authHeaders } from './authService';
import API_BASE from './apiBase';

const ADMIN_URL = `${API_BASE}/admin`;

const request = async (path, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(await authHeaders()),
    ...(options.headers || {}),
  };
  const response = await fetch(`${ADMIN_URL}${path}`, { ...options, headers });
  if (response.status === 204) return null;
  let body = null;
  try {
    body = await response.json();
  } catch (e) {
    /* non-JSON body */
  }
  if (!response.ok) {
    throw new Error(body?.message || `HTTP error! status: ${response.status}`);
  }
  return body;
};

export const fetchUsers = async () => (await request('/users')).users;

export const fetchUser = async (username) => (await request(`/users/${encodeURIComponent(username)}`)).user;

export const fetchGroups = async () => (await request('/groups')).groups;

/** Accounts (partner companies) with customer/user counts. */
export const fetchAccounts = async () => (await request('/accounts')).accounts;

export const createAccount = async (account) =>
  (await request('/accounts', { method: 'POST', body: JSON.stringify(account) })).account;

export const updateAccount = async (id, changes) =>
  (await request(`/accounts/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(changes) })).account;

export const deleteAccount = async (id) => request(`/accounts/${encodeURIComponent(id)}`, { method: 'DELETE' });

export const createUser = async (user) =>
  (await request('/users', { method: 'POST', body: JSON.stringify(user) })).user;

export const updateUser = async (username, changes) =>
  (await request(`/users/${encodeURIComponent(username)}`, { method: 'PUT', body: JSON.stringify(changes) })).user;

export const resetUserPassword = async (username) =>
  request(`/users/${encodeURIComponent(username)}/reset-password`, { method: 'POST' });

export const deleteUser = async (username) =>
  request(`/users/${encodeURIComponent(username)}`, { method: 'DELETE' });
